import { AdvancedSetting } from '../types/AdvancedSetting';
import { apiService } from './apiService';


const AdvancedService = {
    save: async (data: AdvancedSetting) => {
        return apiService.post('/advanced-setting/save', data);
    },

     getByClinicId: async (clinicId: string) =>{
        return apiService.get(`/advanced-setting/clinic/${clinicId}`);
     }
        

};

export default AdvancedService;
